import React, {
  Fragment,
  useCallback,
  useEffect,
  useRef,
  useState,
} from "react";
import { Image, LI } from "../../../../AbstractElements";
import { useSelector } from "react-redux";
import { MdDelete } from "react-icons/md";
import { setChatMessages } from "../../../../utils/chatSlice";
import { useDispatch } from "react-redux";
import Swal from "sweetalert2";
import moment from "moment";
import dark_dropdown_icon from "../../../../../src/assets/images/dark_dropdown_icon.png";
import light_dropdown_icon from "../../../../../src/assets/images/light_dropdown_icon.png";

const ChatMessageItem = ({ item }) => {
  const [userdetails, setUserdetails] = useState(
    JSON.parse(localStorage.getItem("userdetails"))
  );
  const baseurl = useSelector((store) => store.baseUrl);
  const selectedUserr = useSelector((state) => state?.users?.selectedUser);
  const chatMessages = useSelector((state) => state?.chats?.chatmessages);
  const isgroup = useSelector((state) => state?.users?.isGroup);
  const messageId = isgroup ? item.gcm_id : item.chat_id;

  const dispatch = useDispatch();
  const [hoveredMessage, setHoveredMessage] = useState(null); // Tracks hovered message (for icon visibility)
  const [openDropdown, setOpenDropdown] = useState(null); // Tracks open dropdown menu (for menu visibility)
  const dropdownRefs = useRef({});

  // Toggle dropdown when clicking the icon
  const toggleDropdown = (messageId) => {
    setOpenDropdown((prev) => (prev == messageId ? null : messageId));
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        openDropdown &&
        dropdownRefs.current[openDropdown] &&
        !dropdownRefs.current[openDropdown].contains(event.target)
      ) {
        setOpenDropdown(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [openDropdown]);

  const handleMouseEnter = (id) => {
    setHoveredMessage(id); // Set the hovered message ID
  };

  const handleMouseLeave = () => {
    setHoveredMessage(null); // Clear the hovered message ID
  };

  const dropdownIcon = (
    isgroup
      ? item.person_id != userdetails?.employee_id
      : item.sender != userdetails?.employee_id
  )
    ? dark_dropdown_icon
    : light_dropdown_icon;

  // Centralized Fetch Function
  // Handle delete message
  const handleDeleteMessage = async (item) => {
    // Ask for confirmation before proceeding with the API call
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "Do you want to delete this message?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    });

    // If the user confirms, proceed with the deletion
    if (result.isConfirmed) {
      try {
        let apiEndpoint = "";
        const formData = new FormData();

        formData.append("AUTHORIZEKEY", process.env.REACT_APP_AUTHORIZE_KEY);
        formData.append("PHPTOKEN", localStorage.getItem("id_token"));

        if (isgroup) {
          apiEndpoint = `${baseurl}/common_api/user_groupchatdelete/`;
          formData.append("groupid", item?.group_id); // For group chat messages
          formData.append("gcm_id", item?.gcm_id); // For group chat messages
        } else {
          apiEndpoint = `${baseurl}/common_api/deletechat/`;
          formData.append("receiver_id", item?.receiver); // For individual chat messages
          formData.append("receiver_type", item?.receiver_type); // For individual chat messages
          formData.append("sender_id", item?.sender); // For individual chat messages
          formData.append("sender_type", item?.sender_type); // For individual chat messages
          formData.append("chat_id", item?.chat_id); // For individual chat messages
        }

        const response = await fetch(apiEndpoint, {
          method: "POST",
          body: formData,
        });

        const result = await response.json();
        const { STATUS } = result[0] || {};

        if (STATUS == "SUCCESS") {
          // Save the current scroll position before deleting the message
          // Refresh the chat history
          // Filter out the deleted message depending on whether it's a group chat or not
          const updatedMessages = isgroup
            ? chatMessages.filter((message) => message?.gcm_id != item?.gcm_id) // Use gcm_id for group chat
            : chatMessages.filter(
                (message) => message?.chat_id != item?.chat_id
              ); // Use chat_id for individual chat

          // Update the state with the filtered messages
          dispatch(setChatMessages(updatedMessages));
          // After state update, restore the scroll position

          // await fetchChatHistory(selectedUserr, userdetails);
        } else {
          console.error("Failed to delete message:", STATUS);
        }
      } catch (error) {
        console.error("Error deleting message:", error.message);
      }
    } else {
      // console.log("Message deletion canceled.");
    }
  };

  // const fetchChatHistory = async (selectedUserr, userdetails) => {
  //   if (!selectedUserr) return; // Exit if no user is selected

  //   // Only show loading indicator for the first fetch, not for polling
  //   // const isInitialLoad = chatMessages.length === 0;

  //   // if (isInitialLoad) {
  //   //   dispatch(setChatLoading({ isLoading: true }));
  //   // }

  //   try {
  //     let apiEndpoint = "";
  //     const formData = new FormData();

  //     // Append common fields
  //     formData.append("AUTHORIZEKEY", process.env.REACT_APP_AUTHORIZE_KEY);
  //     formData.append("PHPTOKEN", localStorage.getItem("id_token"));

  //     // Determine API endpoint and specific fields
  //     if (isgroup) {
  //       apiEndpoint = `${baseurl}/common_api/openhistorygroupchat/`;
  //       formData.append("groupid", selectedUserr?.group_id);
  //       formData.append("memberid", selectedUserr?.member_id);
  //     } else {
  //       apiEndpoint = `${baseurl}/common_api/openhistorychat/`;
  //       formData.append("receiver_id", selectedUserr.employee_id);
  //       formData.append("receiver_type", selectedUserr.user_type);
  //       const { employee_id: senderId, user_type: senderType } = userdetails;
  //       formData.append("sender_id", senderId);
  //       formData.append("sender_type", senderType);
  //     }

  //     // Fetch data from the API
  //     const response = await fetch(apiEndpoint, {
  //       method: "POST",
  //       body: formData,
  //     });

  //     const result = await response.json();
  //     const { STATUS, DATA } = result[0] || {};

  //     if (STATUS == "SUCCESS" && DATA.length > 0) {
  //       // Compare current messages with the existing messages in Redux state
  //       // const isDataChanged =
  //       //   JSON.stringify(chatMessages) != JSON.stringify(DATA);
  //       // console.log(
  //       //   JSON.stringify(chatMessages) != JSON.stringify(DATA),
  //       //   "json ccompare"
  //       // );

  //       // if (isDataChanged) {
  //       dispatch(setChatMessages(DATA)); // Only update if data is different
  //       // }
  //     } else {
  //       console.error("Failed to fetch chat history:", STATUS);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching chat history:", error.message);
  //   } finally {
  //     // dispatch(setChatLoading({ isLoading: false }));
  //   }
  // };

  const COLORS = [
    "#E57373",
    "#F06292",
    "#BA68C8",
    "#64B5F6",
    "#4DB6AC",
    "#81C784",
    "#FFD54F",
    "#FF8A65",
    "#A1887F",
    "#90A4AE",
  ];

  const getColorFromPersonId = (personId) => {
    if (!personId) return "#000"; // Default color if no ID

    // Ensure personId is treated as a number (convert string to integer)
    const index = Math.abs(parseInt(personId, 10)) % COLORS.length;

    return COLORS[index]; // Return color from the array
  };

  return (
    <Fragment>
      <div
        className={` ${
          isgroup
            ? item.person_id != userdetails?.employee_id
              ? "d-flex"
              : "d-flex flex-row-reverse"
            : item.sender != userdetails?.employee_id
            ? "d-flex"
            : "d-flex flex-row-reverse"
        }`}
      >
        {isgroup && (
          <Image
            attrImage={{
              src: `${item?.photo_path}`,
              className: `rounded-circle ${
                item?.person_id != userdetails?.employee_id
                  ? "float-start"
                  : "float-end ms-2"
              } chat-user-img`,
              alt: "",
              style: {
                width: "25px", // Add padding
                height: "25px",
              },
            }}
          />
        )}
        <LI
          attrLI={{
            className: "chat-message-list clearfix border-0",
            style: {
              // flexBasis: "50%", // Apply flexBasis: 50% only when d-flex is present
            },
          }}
        >
          <div
            className={`message ${
              isgroup
                ? item.person_id != userdetails?.employee_id
                  ? "other-message"
                  : "my-message "
                : item.sender != userdetails?.employee_id
                ? "other-message"
                : "my-message"
            }`}
            // className='message'
            onMouseEnter={() => handleMouseEnter(messageId)} // Track mouse enter
            onMouseLeave={handleMouseLeave} // Track mouse leave
          >
            <div className="message-data">
              <div className="d-flex justify-content-between">
                <div
                  className="username fw-bold"
                  style={{
                    color: getColorFromPersonId(item?.person_id?.toString()),
                    // width: "95%",
                  }} // Apply dynamic color
                >
                  {/* {item?.person_name}  */}
                  {isgroup
                    ? item.person_id != userdetails?.employee_id
                      ? item?.person_name
                      : ""
                    : item.sender != userdetails?.employee_id
                    ? item?.person_name
                    : ""}
                </div>
                {/* {(hoveredMessage == messageId || openDropdown == messageId) && (
                  <div className="dropdown-main ms-auto">
                    <Image
                      attrImage={{
                        src: dropdownIcon,
                        alt: "send_icon",
                        style: { cursor: "pointer"},
                        onClick: () => toggleDropdown(messageId),
                      }}
                    />
                  </div>
                )} */}
              </div>

              {/* Conditionally render delete icon */}
              {/* {hoveredMessage == messageId && ( // Show delete icon only on hover
                // <span className="delete-icon">
                //   <MdDelete
                //     size={20}
                //     color="#FE0606"
                //     onClick={() => handleDeleteMessage(item)}
                //     style={{ cursor: "pointer", marginTop: "12px" }}
                //   />
                // </span>
                <span className="delete-icon">
                  <Image
                    attrImage={{
                      src: dropdownIcon,
                      alt: "send_icon",
                      style: { cursor: "pointer" },
                      onClick: () => toggleDropdown(messageId),
                    }}
                  />
                </span>
              )} */}

              {/* Show dropdown icon when hovered OR if dropdown is open for this message */}
              <div className="d-flex column-gap-1 justify-content-netween flex-nowrap">
                <div>{item?.msg}</div>
                {(hoveredMessage == messageId || openDropdown == messageId) && (
                  <div className="dropdown-main ms-auto">
                    <Image
                      attrImage={{
                        src: dropdownIcon,
                        alt: "send_icon",
                        style: { cursor: "pointer" },
                        onClick: () => toggleDropdown(messageId),
                      }}
                    />
                  </div>
                )}
              </div>
            </div>
            <div
              className="d-flex justify-content-end"
              style={{ marginTop: "10px" }}
            >
              <span className="message-data-time">
                {moment(item?.created_dt, "DD/MM/YYYY hh:mm a").format(
                  "hh:mm a"
                )}
              </span>
            </div>
          </div>

          {/* Show dropdown menu only when the dropdown icon is clicked */}
          {/* {openDropdown == messageId && (
            <div
              ref={(el) => (dropdownRefs.current[messageId] = el)}
              className="dropdown-menu-custom"
              style={{
                top: isgroup
                  ? item.person_id != userdetails?.employee_id
                    ? "43px" // Light gray for others' messages
                    : "23px" // Light blue for user's messages
                  : item.sender != userdetails?.employee_id
                  ? "43px"
                  : "23px",
              }}
            >
              <button
                onClick={() => {
                  navigator.clipboard.writeText(item.msg);
                  setOpenDropdown(null); // Close dropdown after copying
                }}
              >
                Copy
              </button>
              <button
                onClick={() => {
                  setOpenDropdown(null); // Close dropdown after copying
                  handleDeleteMessage(item);
                }}
              >
                Delete
              </button>
            </div>
          )} */}

          {openDropdown == messageId && (
            <div
              ref={(el) => (dropdownRefs.current[messageId] = el)}
              className="dropdown-menu-custom"
              style={{
                top: isgroup
                  ? item.person_id != userdetails?.employee_id
                    ? "43px"
                    : "23px"
                  : item.sender != userdetails?.employee_id
                  ? "43px"
                  : "23px",
              }}
            >
              <button
                onClick={() => {
                  navigator.clipboard.writeText(item.msg);
                  setOpenDropdown(null); // Close dropdown after copying
                }}
              >
                Copy
              </button>

              {/* Conditionally render Delete button */}
              {isgroup ? (
                userdetails?.is_main_admin == "Y" ||
                item.person_id == userdetails?.employee_id ? (
                  <button
                    onClick={() => {
                      setOpenDropdown(null);
                      handleDeleteMessage(item);
                    }}
                  >
                    Delete
                  </button>
                ) : null
              ) : (
                item.sender == userdetails?.employee_id && (
                  <button
                    onClick={() => {
                      setOpenDropdown(null);
                      handleDeleteMessage(item);
                    }}
                  >
                    Delete
                  </button>
                )
              )}
            </div>
          )}
        </LI>
      </div>
    </Fragment>
  );
};

export default ChatMessageItem;
